import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useAuth, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SF_BTCH_EXCUTN_SEARCH_FORM,
    SG_BTCH_EXCUTN_LIST,
} from "@/tra/tancis/ptli/btch/excutn/service/PtliBtchExcutnMgmtService";

/*
 * Managing batch runs list
 * !== 배치실행관리 목록 ==!
 */
export const PTLI1203001Q = (props: any) => {

    useResource({
        defaultSchema: [{ area: "bsopClsfCd" }, { area: "comnCd", comnCd: "COM0024" }],
    })
    
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0047", "auth_ptli0048", "auth_ptli0049"],
    }); 
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Managing batch runs Form !== 배치실행관리 Form ==!
        btchExcutnSrch: useForm({
            defaultSchema: SF_BTCH_EXCUTN_SEARCH_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        btchExcutnSrchList: useGrid({
            defaultSchema: SG_BTCH_EXCUTN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // !== 배치 실행관리 목록을 조회한다.==!
        getBtchExcutnList: useFetch({
            api: (page = grid.btchExcutnSrchList.page) =>
                APIS.getBtchExcutnList(form.btchExcutnSrch.getValues(), page, grid.btchExcutnSrchList.size),
            enabled: comnUtils.isEmpty(form.btchExcutnSrch.errors),
            key: [grid.btchExcutnSrchList.page, grid.btchExcutnSrchList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.btchExcutnSrch.getValues(),
                    page: grid.btchExcutnSrchList.page,
                    size: grid.btchExcutnSrchList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getBtchExcutnList: () => {
            grid.btchExcutnSrchList.setPage(0);
            fetch.getBtchExcutnList.fetch(0);
        },
        // Enter Batch Name !== 배치명 엔터 이벤트 ==!
        onEnterBtchNm: () => {
            grid.btchExcutnSrchList.setPage(0);
            fetch.getBtchExcutnList.fetch(0);
        }
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_btchExcutnSrchList: {
            cell: {
                excutn: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Button
                            variant="secondary"
                            onClick={() => {
                                navigate(`${URLS.ptli1203002s}/${rowValues.btchId}`);
                            }}
                        >
                            {t("B_EXCUTN")}
                        </Button>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.getBtchExcutnList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.btchExcutnSrch.schema.bsopClsfCd} />
                            <Group.Control 
                                {...form.btchExcutnSrch.schema.btchNm}
                                onEnter={handler.onEnterBtchNm}
                             />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.btchExcutnSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getBtchExcutnList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.btchExcutnSrchList.grid} data={fetch.getBtchExcutnList.data?.btchExcutnList} render={render.grid_btchExcutnSrchList}  />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
